export default __webpack_public_path__ + "static/media/andes_a_la_costa_9.ff84ae8b.JPG";